import useRouter from "@hooks/useRouter"

import { TabItem } from "@atoms"

import { TabStack } from "@molecules"

import ComponentNavigation from "@organisms/ComponentNavigation/ComponentNavigation"
import { useComponentNavigation } from "@organisms/ComponentNavigation/ComponentNavigation.context"

import styles from "./PageNavigation.module.scss"
import {
    PageNavigationRootProps,
    PageNavigationTabProps,
    PageNavigationTabsProps,
    PageNavigationViewProps,
} from "./PageNavigation.types"

function PageNavigationRoot(props: PageNavigationRootProps) {
    const { children, initialComponentId, ...historyProps } = props

    return (
        <ComponentNavigation.Provider initialComponentId={initialComponentId} {...historyProps}>
            {children}
        </ComponentNavigation.Provider>
    )
}

function PageNavigationTabs(props: PageNavigationTabsProps) {
    const { children } = props

    return (
        <div className={styles.tabs}>
            <TabStack variant="default" size="md">
                {children}
            </TabStack>
        </div>
    )
}

function PageNavigationTab(props: PageNavigationTabProps) {
    const { componentId, label, linkTo } = props
    const { currentComponentId, navigate } = useComponentNavigation()
    const router = useRouter()

    const isSelected = currentComponentId === componentId

    const handleClick = () => {
        if (linkTo) {
            router.push(linkTo)
        } else {
            navigate(componentId)
        }
    }

    return (
        <TabItem isSelected={isSelected} onClick={handleClick} noDebounce={true}>
            {label}
        </TabItem>
    )
}

function PageNavigationViews(props: PageNavigationTabsProps) {
    const { children } = props

    return (
        <div className={styles.views}>
            <ComponentNavigation.Root>{children}</ComponentNavigation.Root>
        </div>
    )
}

function PageNavigationView(props: PageNavigationViewProps) {
    const { componentId, children } = props

    return <ComponentNavigation.Component componentId={componentId}>{children}</ComponentNavigation.Component>
}

const Root = PageNavigationRoot
const Tabs = PageNavigationTabs
const Tab = PageNavigationTab
const Views = PageNavigationViews
const View = PageNavigationView

export default {
    Root,
    Tabs,
    Tab,
    Views,
    View,
}
